module.exports = __webpack_public_path__ + "img/shopper.31da5ded.jpg";